export default __webpack_public_path__ + "static/typography-image-w-2bc972623370000c4b10967d77d209b4859dd7e2a4b4ccfbfba1e1ce8100e154.png";